import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={11} fill="none" ref={ref} {...props}>
    <rect width={9} height={9} x={0.656} y={0.879} stroke="#383838" rx={4.5} />
    <g stroke="#383838" strokeLinecap="round">
      <path d="M6.844 3.691 3.469 7.066M6.844 7.066 3.469 3.691" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconEncircledX = memo(ForwardRef);
export default IconEncircledX;
